// src/app/reducers/auth.ts

// import { Socket } from 'socket.io-client';

export const CONNECTING = 'CONNECTING';
export const CONNECTED = 'CONNECTED';
export const DISCONNECTED = 'DISCONNECTED';

type ConnType = typeof CONNECTING | typeof CONNECTED | typeof DISCONNECTED;

type StateType = {
  status: string;
  socket: any | null;
  socketId: string | null;
  socketIdClosed: any | null;
};

const initialState: StateType = {
  status: 'Disconnected',
  socket: null,
  socketId: null,
  socketIdClosed: null,
};

const socketConnectionReducer = (
  state = initialState,
  action: { type: ConnType; payload: StateType },
): StateType => {
  switch (action.type) {
    case CONNECTED:
      return {
        ...state,
        status: action.payload.status,
        socketId: action.payload.socketId,
        socket: action.payload.socket,
      };
    case CONNECTING:
    case DISCONNECTED:
      return {
        ...state,
        status: action.payload.status,
        socketIdClosed: state.socketId,
        socketId: null,
        socket: null,
      };
    default:
      return {...state};
  }
};

export default socketConnectionReducer;
